import classNames from "classnames";
import {Button} from "react-bootstrap";
import {Instrument} from "../../../../generated/graphql";
import {getAssetGroup} from "../../../profile/utils";

interface UnderlyingSearchResultItemProps {
    onCustomAssetSelect: (instrument: Instrument) => any;
    instrument: Instrument;
}

export default function UnderlyingSearchResultItem(props: UnderlyingSearchResultItemProps) {
    const {name, wkn, group} = props.instrument;
    return (<>
        <div className="result-item">
            <Button className="name text-left p-0" variant="link" onClick={() => props.onCustomAssetSelect(props.instrument)}>
                {name}
            </Button>
            <div className="d-flex justify-content-between">
                <span className={classNames("text-center", {'d-none': !wkn})}>WKN: {wkn}</span>
                <span className={classNames("asset-type-text-color font-weight-bold", group.assetGroup)}>{group.assetGroup && getAssetGroup(group.assetGroup)}</span>
            </div>
        </div>
    </>);
}

